module.exports = __webpack_public_path__ + "img/secondary_8x3.ff9e6162.svg";